import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import TimestampManager from '../../utils/TimestampManager';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import { TimedBonusKeys } from '../../api/Constants';
import BonusInterface from '../../api/BonusInterface';
import PushNotification from '../../lib/notifications/PushNotification';
import InboxMessagesProvider from '../InboxMessagesProvider';
import audio from '../../utils/audio';
import Screens from '../../screens';
import RewardCenterOnboarding from '../../utils/rewardCenterOnboarding';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FE_MISSIONS } from '../../utils/featureFlags/constants';
import { MISSIONS_EVENT_TYPES, MISSIONS_GAMEPLAY_STATUS } from '../../screens/Missions/constants';
import { sendMissionsEvent } from '../../screens/Missions/analytics/missionsLogger';
import Utils from '../../utils';
import { PLATFORM } from '../../constants';

var BottomBar = /*#__PURE__*/function (_Component) {
  _inherits(BottomBar, _Component);

  var _super = _createSuper(BottomBar);

  function BottomBar() {
    var _this;

    _classCallCheck(this, BottomBar);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));
    _this.state = {
      visible: true,
      openChest: false,
      videoAdsTimeUntilReset: 0,
      claimingBonus: false,
      isFirstRender: true
    };
    _this.videoAdsTimer = undefined;

    _this.checkTimerToReset = function (timeLeft) {
      clearTimeout(_this.timerCheck);
      _this.timerCheck = setTimeout(function () {
        return _this._timedBonusReady();
      }, timeLeft);
    };

    _this._checkTimedBonus = function (args) {
      if (args) {
        var tb = transformObjectResponseKeys(args, TimedBonusKeys);
        var newDate = new Date(tb.TIME_LEFT);
        tb.TIME_LEFT = newDate.getTime() - new Date().getTime();

        if (tb.TIME_LEFT <= 0) {
          _this.setState(_objectSpread(_objectSpread({}, tb), {}, {
            openChest: true,
            TIME_LEFT: 0
          }));
        } else {
          _this.checkTimerToReset(tb.TIME_LEFT);

          tb.TIME_LEFT = Date.now() + tb.TIME_LEFT;

          _this.setState(_objectSpread(_objectSpread({}, tb), {}, {
            openChest: false
          }));
        }
      }
    };

    _this._timedBonusReady = function () {
      _this.setState({
        openChest: true,
        TIME_LEFT: 0
      });
    };

    _this._showModal = function (modalType) {
      audio.onClick();
      var _this$props = _this.props,
          sidebarState = _this$props.sidebarState,
          setSidebarState = _this$props.setSidebarState;
      setSidebarState(!sidebarState);

      if (modalType === Screens.RewardCenter) {
        RewardCenterOnboarding.showModal(modalType);
      } else {
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));
      }
    };

    _this._timedBonusHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, timeLeft;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();
              audio.playCoinSfx();
              _context.prev = 2;

              _this.setState({
                claimingBonus: true
              });

              _context.next = 6;
              return BonusInterface.claimTimedBonus();

            case 6:
              response = _context.sent;
              timeLeft = response.timeLeft;

              if (response) {
                Utils.getPlatform() !== PLATFORM.WEB && PushNotification.scheduleTimedBonusNotification(timeLeft);
                response.timeLeft = Date.now() + response.timeLeft * 1000;

                _this.props.setTimedBonus(response);

                _this._checkTimedBonus(response);

                _this.props.getMissions({
                  playerId: _this.props.playerId,
                  requestAssetsData: false
                }, {
                  subscribe: false,
                  forceRefetch: true
                });
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

            case 14:
              _this.setState({
                claimingBonus: false
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    _this._setVideoAdsTimeRemaining = function (secondsRemaining) {
      var timeRemaining = secondsRemaining * 1000;
      _this.videoAdsTimer = TimestampManager.register(timeRemaining, _this._videoAdsReady);

      _this.setState({
        videoAdsTimeUntilReset: Date.now() + timeRemaining
      });
    };

    _this._videoAdsReady = function () {
      _this.setState({
        videoAdsTimeUntilReset: 0
      });
    };

    _this._getMessageCount = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this.props;
              _context2.next = 3;
              return InboxMessagesProvider.getMessageCount();

            case 3:
              _context2.t1 = _context2.sent;

              _context2.t0.updateUnreadMessageCount.call(_context2.t0, _context2.t1);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this._onInboxUpdateHandler = function () {
      _this._getMessageCount();
    };

    return _this;
  }

  _createClass(BottomBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.isFirstRender && this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        isFirstRender: false
      }));

      this._checkTimedBonus(this.props.timedBonus);

      if (this.props.videoAds && this.props.videoAds.secondsUntilReset > 0) {
        this._setVideoAdsTimeRemaining(this.props.videoAds.secondsUntilReset);
      }

      InboxMessagesProvider.on(InboxMessagesProvider.EVENTKEY, this._onInboxUpdateHandler);

      this._getMessageCount();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newNavState = nextProps.navState;

      if (newNavState !== this.props.navState) {
        switch (newNavState) {
          case NavigationConstants.HIDE_BOTTOM:
            this.setState({
              visible: false
            });
            break;

          case NavigationConstants.HIDE_BOTH:
            {
              this.setState({
                visible: false
              });
              break;
            }

          default:
            {
              this.setState({
                visible: true
              });
            }
        }
      }

      var newVideoAds = nextProps.videoAds;

      if (newVideoAds !== this.props.videoAds && newVideoAds.secondsUntilReset > 0) {
        this._setVideoAdsTimeRemaining(newVideoAds.secondsUntilReset);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TimestampManager.unregister(this.videoAdsTimer);
      clearTimeout(this.timerCheck);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (this.state.visible !== nextState.visible) {
        if (this.props.sharedWillUpdate) {
          this.props.sharedWillUpdate(nextProps, nextState);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _useFeatureFlags = useFeatureFlags(),
          hasFeature = _useFeatureFlags.hasFeature;

      var showMissionsButton = hasFeature(FE_MISSIONS) && this.props.missionsFeature !== MISSIONS_GAMEPLAY_STATUS.PENDING && this.props.missionsFeature !== MISSIONS_GAMEPLAY_STATUS.PAUSED && this.props.missionsFeature !== MISSIONS_GAMEPLAY_STATUS.CANCELED && this.props.missionsAssetsPackage;
      showMissionsButton && this.state.isFirstRender && sendMissionsEvent(MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_WIDGET);
      return this.props.render(_objectSpread({
        canEnterVipRoom: this.props.canEnterVipRoom,
        isVipRoomUnlocked: this.props.isVipRoomUnlocked,
        showModal: this._showModal,
        timedBonusHandle: this._timedBonusHandler,
        videoAds: {
          remaining: this.props.videoAds.remaining,
          timeUntilReset: this.state.videoAdsTimeUntilReset
        },
        appBackground: this.props.appBackground,
        sidebarState: this.props.sidebarState,
        setSidebarState: this.props.setSidebarState,
        unreadMessageCount: this.props.unreadMessageCount,
        showMissionsButton: showMissionsButton
      }, this.state));
    }
  }]);

  return BottomBar;
}(Component);

export { BottomBar as default };